import { DrawerProps } from '@mui/material';
import { forwardRef } from 'react';

import { Drawer as MuiDrawer } from './Drawer.styled';

export const Drawer = forwardRef(
  (props: DrawerProps & { width?: number | string }, ref) => {
    return (
      <MuiDrawer ref={ref} anchor="left" variant="persistent" {...props} />
    );
  },
);
